<div class="bw-dialog">

    <lib-page-header [title]="title" backTo="">
        <mat-icon icon>{{ icon }}</mat-icon>
        <span subtitle>{{ subtitle }}</span>
    </lib-page-header>

    <div class="bw-body">
        <div class="picker-panel app-panel">
            <mat-form-field class="full" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Data Type</mat-label>
                <mat-select [(ngModel)]="selectedDataType">
                    @for (dataType of dataTypeList; track dataType) {
                        <mat-option [value]="dataType">{{dataType}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Destructive-action warning. Only shown when the caller marks the
             dialog destructive (e.g. purge flows). Red-accent left border +
             warning icon + bold title so the operator can't miss it. -->
        <div class="warning-banner" *ngIf="destructive">
            <mat-icon class="warning-icon">warning_amber</mat-icon>
            <div class="warning-text">
                <div class="warning-title">{{ warningTitle }}</div>
                <div class="warning-message">{{ warningMessage }}</div>
            </div>
        </div>
    </div>

    <mat-dialog-actions class="dialog-actions" align="end">
        <button mat-button (click)="onCloseClicked()">Cancel</button>
        <button mat-flat-button
                [color]="destructive ? 'warn' : 'primary'"
                [class.danger-action]="destructive"
                [mat-dialog-close]="selectedDataType"
                cdkFocusInitial
                [disabled]="!hasSelection()">
            <mat-icon>{{ confirmIcon }}</mat-icon>
            {{ confirmLabel }}
        </button>
    </mat-dialog-actions>

</div>
